import React from "react";

const SquareOneHeartPlusPlus = ({ ...rest }) => {
    return (
        <svg
            width="354"
            height="291"
            viewBox="0 0 354 291"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g clipPath="url(#clip0_16545_23459)">
                <rect
                    x="215.402"
                    y="187.947"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 215.402 187.947)"
                    fill="#E0E9EA"
                />
                <rect x="218.738" y="181.831" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="215.402"
                    y="208.522"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 215.402 208.522)"
                    fill="#E0E9EA"
                />
                <rect x="218.738" y="202.405" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="215.402"
                    y="229.096"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 215.402 229.096)"
                    fill="#E0E9EA"
                />
                <rect x="218.738" y="222.979" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="235.977"
                    y="187.947"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 235.977 187.947)"
                    fill="#E0E9EA"
                />
                <rect x="239.313" y="181.831" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="235.977"
                    y="208.522"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 235.977 208.522)"
                    fill="#E0E9EA"
                />
                <rect x="239.313" y="202.405" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="235.977"
                    y="229.096"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 235.977 229.096)"
                    fill="#E0E9EA"
                />
                <rect x="239.313" y="222.979" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="256.551"
                    y="187.947"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 256.551 187.947)"
                    fill="#E0E9EA"
                />
                <rect x="259.887" y="181.831" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="256.551"
                    y="208.522"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 256.551 208.522)"
                    fill="#E0E9EA"
                />
                <rect x="259.887" y="202.405" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="256.551"
                    y="229.096"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 256.551 229.096)"
                    fill="#E0E9EA"
                />
                <rect x="259.887" y="222.979" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="277.125"
                    y="187.947"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 277.125 187.947)"
                    fill="#E0E9EA"
                />
                <rect x="280.461" y="181.831" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="277.125"
                    y="208.522"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 277.125 208.522)"
                    fill="#E0E9EA"
                />
                <rect x="280.461" y="202.405" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="277.125"
                    y="229.096"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 277.125 229.096)"
                    fill="#E0E9EA"
                />
                <rect x="280.461" y="222.979" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="297.699"
                    y="187.947"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 297.699 187.947)"
                    fill="#E0E9EA"
                />
                <rect x="301.035" y="181.831" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="297.699"
                    y="208.522"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 297.699 208.522)"
                    fill="#E0E9EA"
                />
                <rect x="301.035" y="202.405" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="297.699"
                    y="229.096"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 297.699 229.096)"
                    fill="#E0E9EA"
                />
                <rect x="301.035" y="222.979" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="215.402"
                    y="251.338"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 215.402 251.338)"
                    fill="#E0E9EA"
                />
                <rect x="218.738" y="245.221" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="215.402"
                    y="271.912"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 215.402 271.912)"
                    fill="#E0E9EA"
                />
                <rect x="218.738" y="265.795" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="235.977"
                    y="251.338"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 235.977 251.338)"
                    fill="#E0E9EA"
                />
                <rect x="239.313" y="245.221" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="235.977"
                    y="271.912"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 235.977 271.912)"
                    fill="#E0E9EA"
                />
                <rect x="239.313" y="265.795" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="256.551"
                    y="251.338"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 256.551 251.338)"
                    fill="#E0E9EA"
                />
                <rect x="259.887" y="245.221" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="256.551"
                    y="271.912"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 256.551 271.912)"
                    fill="#E0E9EA"
                />
                <rect x="259.887" y="265.795" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="277.125"
                    y="251.338"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 277.125 251.338)"
                    fill="#E0E9EA"
                />
                <rect x="280.461" y="245.221" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="277.125"
                    y="271.912"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 277.125 271.912)"
                    fill="#E0E9EA"
                />
                <rect x="280.461" y="265.795" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="297.699"
                    y="251.338"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 297.699 251.338)"
                    fill="#E0E9EA"
                />
                <rect x="301.035" y="245.221" width="2.78029" height="9.45297" fill="#E0E9EA" />
                <rect
                    x="297.699"
                    y="271.912"
                    width="2.78029"
                    height="9.45297"
                    transform="rotate(-90 297.699 271.912)"
                    fill="#E0E9EA"
                />
                <rect x="301.035" y="265.795" width="2.78029" height="9.45297" fill="#E0E9EA" />
            </g>
            <rect
                x="79.1338"
                y="49.3153"
                width="211.024"
                height="211.024"
                stroke="#1C234D"
                strokeWidth="11.4687"
            />
            <path
                d="M66.8018 199.733C74.8671 214.554 93.4196 220.03 108.24 211.964"
                stroke="#B0C8CD"
                strokeWidth="9.93952"
            />
            <path
                d="M315.089 25.149H324.946V33.9693H315.089V44.3453H306.269V33.9693H295.892V25.149H306.269V15.2916H315.089V25.149Z"
                fill="#283A97"
            />
            <circle cx="185.028" cy="155.21" r="63.46" fill="#91B0B8" />
            <circle
                cx="189.615"
                cy="161.326"
                r="63.0778"
                stroke="#1C234D"
                strokeWidth="0.764579"
            />
            <path
                d="M182.388 174.73V145.413L184.431 148.101L171.959 152.653V142.761L189.807 136.095H192.674V174.73H182.388ZM171.851 174.73V166.021H201.741V174.73H171.851Z"
                fill="white"
            />
            <path
                d="M153.422 95.1896C156.538 95.1896 158.929 96.0333 160.646 97.676C162.36 99.3163 163.238 101.605 163.238 104.592C163.238 107.527 161.687 110.569 158.472 113.722L145.182 126.266L145.176 126.271C144.994 126.449 144.779 126.538 144.505 126.538C144.232 126.538 144.016 126.449 143.834 126.271L143.83 126.266L130.518 113.68L130.504 113.668L130.491 113.657L130.261 113.458C130.17 113.373 130.063 113.27 129.94 113.146C129.706 112.909 129.321 112.466 128.781 111.804C128.251 111.155 127.777 110.488 127.36 109.807C126.952 109.14 126.582 108.324 126.254 107.355C125.932 106.4 125.773 105.48 125.773 104.592C125.773 101.605 126.65 99.3163 128.365 97.676C130.082 96.0332 132.473 95.1896 135.588 95.1896C136.426 95.1896 137.286 95.332 138.168 95.6203C139.055 95.9101 139.879 96.3007 140.64 96.7912C141.422 97.2951 142.091 97.7655 142.648 98.2023C143.206 98.6397 143.736 99.105 144.238 99.5969L144.505 99.8586L144.773 99.5969C145.275 99.105 145.805 98.6397 146.363 98.2023C146.92 97.7654 147.59 97.2952 148.372 96.7912C149.133 96.3008 149.956 95.91 150.843 95.6203C151.726 95.3321 152.585 95.1897 153.422 95.1896Z"
                fill="white"
                stroke="black"
                strokeWidth="0.764579"
            />
            <path
                d="M140.682 123.862C140.313 123.862 140 123.736 139.744 123.485L126.432 110.9C126.29 110.788 126.094 110.607 125.845 110.356C125.596 110.105 125.202 109.649 124.661 108.987C124.121 108.325 123.637 107.645 123.211 106.948C122.784 106.252 122.403 105.408 122.069 104.419C121.735 103.429 121.568 102.467 121.568 101.534C121.568 98.4674 122.471 96.0701 124.277 94.3419C126.083 92.6136 128.579 91.7495 131.765 91.7495C132.647 91.7495 133.546 91.8993 134.464 92.1989C135.381 92.4986 136.234 92.9028 137.024 93.4115C137.813 93.9202 138.492 94.3976 139.061 94.8436C139.63 95.2896 140.17 95.7635 140.682 96.2652C141.194 95.7635 141.735 95.2896 142.304 94.8436C142.873 94.3976 143.552 93.9202 144.341 93.4115C145.13 92.9028 145.984 92.4986 146.901 92.1989C147.818 91.8993 148.718 91.7495 149.6 91.7495C152.785 91.7495 155.281 92.6136 157.088 94.3419C158.894 96.0701 159.797 98.4674 159.797 101.534C159.797 104.614 158.168 107.75 154.912 110.942L141.621 123.485C141.365 123.736 141.052 123.862 140.682 123.862Z"
                fill="#F15D2A"
            />
            <defs>
                <clipPath id="clip0_16545_23459">
                    <rect
                        width="97.8661"
                        height="97.8661"
                        fill="white"
                        transform="translate(209.495 177.382)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default SquareOneHeartPlusPlus;
